import { useStreamChat } from '@/hooks/useStreamChat'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import useTheme from '@mui/material/styles/useTheme'
import { Suspense, lazy } from 'react'

import { useRoleRestrictions } from '@/hooks/permissions/useRoleRestrictions'
import CustomLoading from '../Loading'

import ChannelList from './ChannelList'

const ChatChannel = lazy(() => import('./ChatChannel'))

const GetStreamChatDrawer: React.FC = () => {
  const theme = useTheme()

  const {
    messageDrawerOpen,
    setMessageDrawerOpen,
    activeChannelId,
    closeMessageDrawer,
  } = useStreamChat()
  const { checkAndBlock } = useRoleRestrictions()

  return (
    <SwipeableDrawer
      anchor="right"
      open={messageDrawerOpen}
      // Case Manager Restrictions validation as part of https://attorney.atlassian.net/browse/MP-3774
      onOpen={() => checkAndBlock(() => setMessageDrawerOpen(true))}
      onClose={closeMessageDrawer}
      sx={{
        zIndex: theme.zIndex.tooltip + 1,
        '& .MuiDrawer-paper': {
          width: '100%',
          maxWidth: {
            sm: '100%',
            md: '600px',
          },
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <ChannelList />
      {activeChannelId && (
        <Suspense fallback={<CustomLoading />}>
          <ChatChannel />
        </Suspense>
      )}
    </SwipeableDrawer>
  )
}

export default GetStreamChatDrawer
